@if (isContentLoaded) {
  @if (navigating) {
    <div class="navigating"></div>
  }
  @if (!pageIsFullScreen) {
    <header
      appHeader
      (menuOpened)="menuOpened = true"
      class="header"
      [class.header--unsticky]="headerUnsticky"
      [appHeightVariable]="{ name: 'heightAppHeader', setToRoot: true }"
    ></header>
  }
  @if (menuOpened) {
    <app-menu
      [currentUser]="currentUser"
      (menuClosed)="menuOpened = false"
    ></app-menu>
  }
  <main [attr.data-cy-loggedin]="currentUser?.uuid">
    <router-outlet></router-outlet>
  </main>
  @if (!pageIsStandalone && !pageIsFullScreen) {
    @if (!pageHasMinimalFooter) {
      <footer appFooter></footer>
    }
    @if (pageHasMinimalFooter) {
      <footer appFooterMinimal></footer>
    }
  }
  <ng-template #playerContainer></ng-template>
  <ng-template #migrationContainer></ng-template>
  <ng-template #humanServerErrorModalTemplate>
    <app-error-modal
      [humanError]="humanServerError"
      (closed)="clearServerError()"
    ></app-error-modal>
  </ng-template>
  <ng-template #confirmModalTemplate>
    <app-confirm [message]="confirm.message"></app-confirm>
  </ng-template>
  @if (notice) {
    <ng-template #noticeModalTemplate>
      <div class="_modal--notice">
        <header class="_modal-header">
          <h1 class="_modal-title" i18n>{{ notice.title }}</h1>
        </header>
        <section class="_modal-content">
          <div class="_text" [innerHTML]="notice.text"></div>
        </section>
        @if (!notice.preventClose) {
          <section class="_modal-actions">
            <button
              type="button"
              (click)="closeNotice()"
              class="_button--notice"
              i18n
            >
              Sluiten
            </button>
          </section>
        }
      </div>
    </ng-template>
  }
}
@if (!isContentLoaded) {
  <main>
    <router-outlet></router-outlet>
  </main>
}
